<template>
  <div class="toast-wrapper">
    <v-snackbar top class="toast__element" v-model="toastOpen" :timeout="-1">
      <v-icon class="toast__icon" :size="24"> mdi-information </v-icon>
      <span class="toast__content">
        {{ $t("settings.user_view.toast_title_1") }}
        <span class="user-email">{{ this.$store.state.user.email }}</span>
        {{ $t("settings.user_view.toast_title_2") }}
      </span>
      <v-btn class="toast-button" outlined @click="endSession">
        <v-icon size="16">{{ mdiClose }}</v-icon>
        {{ $t("settings.user_view.end_session") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import { mdiClose } from "@mdi/js";
  import { eventBus } from "@/event-bus";

  export default {
    name: "ImpersonateToast",
    data() {
      return {
        color: "",
        redirectLink: null,
        mdiClose: mdiClose,
        toastOpen: !!this.$store.state.user.impersonate,
      };
    },
    methods: {
      async endSession() {
        this.$store.commit("SET_USER_EMAIL", this.$store.state.user.originalUser.email);
        this.$store.commit("SET_USER_ID", this.$store.state.user.originalUser.id);
        this.$store.commit("SET_USER_IMPERSONATE", null);
        this.$store.commit("SET_ORIGINAL_USER", null);

        await this.$store.dispatch("refreshAndStoreAllUserData");
        this.toastOpen = false;
        eventBus.$emit("end-impersonate");
        this.$router.push({ name: "settings", query: { tab: "user_view" } });
      },
    },
    mounted() {
      //Event watch for impersonate start to show toast (watchers don't work with store)
      eventBus.$on("init-impersonate", () => {
        this.toastOpen = this.$store.state.user.impersonate;
      });
    },
    beforeDestroy() {
      eventBus.$off("init-impersonate");
    },
  };
</script>

<style scoped lang="scss">
  @import "@core/preset/preset/functions.scss";

  .toast-wrapper {
    &::v-deep {
      .v-snack__wrapper {
        background-color: get-color("info");
      }
    }

    .user-email {
      text-decoration: underline;
    }

    .toast__element {
      top: 16px;
      left: 50%;
      z-index: 999;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      position: fixed;
      transition: transform 0.8s ease-in-out;

      .toast__content {
        margin-right: 30px;
      }

      .toast-button {
        max-width: unset !important;
        min-width: unset !important;
        padding-left: 12px !important;
        padding-right: 12px !important;

        .v-icon {
          margin-right: 4px;
        }
      }
    }
    .menu-open {
      .toast__element {
        @media (min-width: 1264px) {
          transform: translateX(calc(-50% + 130px));
        }
      }
    }
  }
</style>
